import { render } from "./Company.vue?vue&type=template&id=9ed0f9ae&ts=true"
import script from "./Company.vue?vue&type=script&setup=true&lang=ts"
export * from "./Company.vue?vue&type=script&setup=true&lang=ts"

import exportComponent from "/builds/easy/webapp/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"resources/js/Layouts/Company.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "9ed0f9ae"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('9ed0f9ae', __exports__)) {
    console.log('reload')
    api.reload('9ed0f9ae', __exports__)
  }
  
  module.hot.accept("./Company.vue?vue&type=template&id=9ed0f9ae&ts=true", () => {
    console.log('re-render')
    api.rerender('9ed0f9ae', render)
  })

}


export default __exports__